var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bs-wrapper"},[_c('div',{ref:"content",staticClass:"content"},[_c('div',{staticClass:"result-background",style:({
            background:`url(${_vm.isInvalidState
              ? require('../../assets/img/questionnaire/result_invalid.png')
              : require('../../assets/img/questionnaire/result_success.png')}) no-repeat`,
            backgroundSize: '100%'
        })}),_c('div',{staticClass:"result-text"},[_vm._v(_vm._s((_vm.$route.params.err && _vm.$route.params.err.message) || '获取问卷状态失败'))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }